<div class="inner-navigation">
  <div class="back" (click)="navigateBack()">
    <p class="text-button-small">{{ 'chat-claim-details.back-button' | translate }}</p>
  </div>
</div>

@if (voucher) {
  <div class="detail-title">
    <div class="status voucher">
      <p class="tag-12">{{ 'voucher-details.badge' | translate }}</p>
    </div>
    <div class="title">
      <h4>{{ 'vouchers.partner-title' | translate:voucher.values }}</h4>
    </div>
  </div>
  <div class="details-part info">
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'voucher-details.fields.code' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ voucher.values['couponCode'] }}</p>
        </div>
      </div>
      <button
        class="copy-button"
        [cdkCopyToClipboard]="voucher.values['couponCode']"
        (cdkCopyToClipboardCopied)="onCouponCopied()">
        <mat-icon svgIcon="copy"></mat-icon>
      </button>
      <span class="copy-feedback" [class.visible]="copied">
        {{ 'voucher-details.coupon-copied' | translate }}
      </span>
    </div>
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'voucher-details.fields.information' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ getInformationTranslationKey() | translate:voucher.values }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="vertical">
        <div class="title">
          <p class="body-12">{{ 'voucher-details.fields.issued-on' | translate }}</p>
        </div>
        <div class="value">
          <p class="subtitle-14">{{ voucher.dateCreated | date: 'dd.MM.yyyy' }}</p>
        </div>
      </div>
    </div>
  </div>
}
